import { DARK_SQUARE_PARITY } from '../utils/constants.js';
import type { Color, Square } from './types.js';

export interface Direction {
  readonly dr: -1 | 1;
  readonly dc: -1 | 1;
}

export const ALL_DIAGONALS: readonly Direction[] = [
  { dr: -1, dc: -1 },
  { dr: -1, dc: 1 },
  { dr: 1, dc: -1 },
  { dr: 1, dc: 1 },
];

export function isDarkSquare(square: Square): boolean {
  return (square.row + square.col) % 2 === DARK_SQUARE_PARITY;
}

export function inBounds(square: Square, boardSize: number): boolean {
  return (
    square.row >= 0 &&
    square.row < boardSize &&
    square.col >= 0 &&
    square.col < boardSize
  );
}

export function forwardDirection(color: Color): -1 | 1 {
  return color === 'white' ? -1 : 1;
}

export function promotionRow(color: Color, boardSize: number): number {
  return color === 'white' ? 0 : boardSize - 1;
}

export function isPromotionSquare(
  square: Square,
  color: Color,
  boardSize: number,
): boolean {
  return square.row === promotionRow(color, boardSize);
}

export function offset(square: Square, dir: Direction, distance: number): Square {
  return { row: square.row + dir.dr * distance, col: square.col + dir.dc * distance };
}
